import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import RootState from "../../redux/states/root.state";
import Header from "../../components/common/Header/Header";
import { fetchCommands } from "../../redux/actions/commands.actions";
import CommandsContainer from "./components/CommandsContainer";
import AddCommandModal from "./components/AddCommandModal";
import UpdateCommandModal from "./components/UpdateCommandModal";
import DeleteCommandModal from "./components/DeleteCommandModal";
import { TerminalLineIcon } from "../../components/common/Icons/Icons";

const CommandsPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];
  const {meta} = useSelector((state: RootState) => state.commands);

  const [addOpen, setAddOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [commandToModify, setCommandToModify] = useState(null);

  useEffect(() => {
    dispatch(fetchCommands(searchParams.toString()));
  }, [dispatch,searchParams]);

  return (
    <div className="page lp-page">
      <AddCommandModal open={addOpen} setOpen={setAddOpen}/>
      <UpdateCommandModal open={editOpen} setOpen={setEditOpen} object={commandToModify}/>
      <DeleteCommandModal open={deleteOpen} setOpen={setDeleteOpen} object={commandToModify}/>

      <Header
        header="API Commands"
        headerExtra={meta?.total !== undefined &&
          <ul className="lp-stats" aria-label="Summary">
            <li className="lp-stat"><TerminalLineIcon/><b>{(meta?.total ?? 0).toLocaleString()}</b> Commands</li>
          </ul>
        }
      />
      <main className="lp-main">
        <CommandsContainer
          setAddOpen={setAddOpen}
          setEditOpen={setEditOpen}
          setDeleteOpen={setDeleteOpen}
          setCommandToModify={setCommandToModify}
        />
      </main>
    </div>
  );
};

export default CommandsPage;
